import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../context/AuthProvider";
import LoadingPage from "../components/LoadingPage";

const PublicRoute = () => {
  const { user, loading } = useAuth();

  if (loading) {
    return <LoadingPage />;
  }

  if (user) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
};

export default PublicRoute;
